(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[584],{

/***/ 5033:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/page/[pageIndex]",
      function () {
        return __webpack_require__(3294);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



var Advert = function(param) {
    var language = param.language;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (true) {
            window.adsbygoogle = window.adsbygoogle || [];
            window.adsbygoogle.push({});
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            background: "#ffffff07",
            marginTop: "1rem"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: language === "en" ? "Advertisement" : "Mainos"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
                className: "adsbygoogle",
                style: {
                    display: "block"
                },
                "data-ad-client": "ca-pub-5560402633923389",
                "data-ad-slot": "1051764153",
                "data-ad-format": "auto",
                "data-full-width-responsive": "true"
            })
        ]
    }, router.asPath);
};
/* harmony default export */ __webpack_exports__["Z"] = (Advert);


/***/ }),

/***/ 5625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_Pagination_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3027);
/* harmony import */ var _styles_Pagination_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_Pagination_module_css__WEBPACK_IMPORTED_MODULE_3__);




var Pagination = function(param) {
    var numPages = param.numPages, currentPage = param.currentPage, language = param.language;
    var isFirst = currentPage === 1;
    var isLast = currentPage === numPages;
    var languageSpecificBase = "".concat(language === "en" ? "/blog/page/" : "/blogi/sivu/");
    var previousPage = "".concat(languageSpecificBase).concat(currentPage - 1);
    var nextPage = "".concat(languageSpecificBase).concat(currentPage + 1);
    if (numPages === 1) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    !isFirst && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "prev",
                        href: "https://niemenjoki.fi" + previousPage
                    }),
                    !isLast && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "next",
                        href: "https://niemenjoki.fi" + nextPage
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_Pagination_module_css__WEBPACK_IMPORTED_MODULE_3___default().Pagination),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    children: [
                        !isFirst && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: previousPage,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: (_styles_Pagination_module_css__WEBPACK_IMPORTED_MODULE_3___default().TextButton),
                                    children: language === "en" ? "Previous" : "Edellinen"
                                })
                            })
                        }, "previous"),
                        Array.from({
                            length: numPages
                        }, function(_, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "".concat(languageSpecificBase).concat(i + 1),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: (_styles_Pagination_module_css__WEBPACK_IMPORTED_MODULE_3___default().NumberButton),
                                        children: i + 1
                                    })
                                })
                            }, i);
                        }),
                        !isLast && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: nextPage,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: (_styles_Pagination_module_css__WEBPACK_IMPORTED_MODULE_3___default().TextButton),
                                    children: language === "en" ? "Next" : "Seuraava"
                                })
                            })
                        }, "next")
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 4438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2106);
/* harmony import */ var _styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2__);



var Post = function(param) {
    var post = param.post, _compact = param.compact, compact = _compact === void 0 ? false : _compact, language = param.language;
    var blogInLanguage = language === "en" ? "blog" : "blogi";
    var postInLanguage = language === "en" ? "post" : "julkaisu";
    var pageInLanguage = language === "en" ? "page" : "sivu";
    if (typeof post.tags === "string") {
        post.tags = post.tags.split(",").map(function(tag) {
            return tag.trim();
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Post),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Title),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/".concat(post.altPath || "".concat(blogInLanguage, "/").concat(postInLanguage), "/").concat(post.slug),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        children: post.title
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Excerpt),
                children: post.excerpt
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Tags),
                children: post.tags && post.tags.map(function(tag) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/".concat(blogInLanguage, "/").concat(tag.toLowerCase(), "/").concat(pageInLanguage, "/1"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Tag),
                            children: tag
                        })
                    }, tag);
                })
            }),
            !compact && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/".concat(post.altPath || "".concat(blogInLanguage, "/").concat(postInLanguage), "/").concat(post.slug),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    "aria-label": "".concat(language === "en" ? "Open post" : "Avaa julkaisu", " ").concat(post.title),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                        children: [
                            language === "en" ? "Read more" : "Lue lis\xe4\xe4",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Arrow),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Post);


/***/ }),

/***/ 1340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SearchPosts; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}

;// CONCATENATED MODULE: ./hooks/useTimeout.js

var useTimeout = function(callback, delay) {
    var callbackRef = (0,react.useRef)(callback);
    var timeoutRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        callbackRef.current = callback;
    }, [
        callback
    ]);
    var set = (0,react.useCallback)(function() {
        timeoutRef.current = setTimeout(function() {
            return callbackRef.current();
        }, delay);
    }, [
        delay
    ]);
    var clear = (0,react.useCallback)(function() {
        timeoutRef.current && clearTimeout(timeoutRef.current);
    }, []);
    (0,react.useEffect)(function() {
        set();
        return clear;
    }, [
        delay,
        set,
        clear
    ]);
    var reset = (0,react.useCallback)(function() {
        clear();
        set();
    }, [
        clear,
        set
    ]);
    return {
        reset: reset,
        clear: clear
    };
};
/* harmony default export */ var hooks_useTimeout = (useTimeout);

;// CONCATENATED MODULE: ./hooks/useDebounce.js



var useDebounce = function(callback, delay, dependencies) {
    var ref = hooks_useTimeout(callback, delay), reset = ref.reset, clear = ref.clear;
    (0,react.useEffect)(reset, _toConsumableArray(dependencies).concat([
        reset
    ]));
    (0,react.useEffect)(clear, []);
};
/* harmony default export */ var hooks_useDebounce = (useDebounce);

// EXTERNAL MODULE: ./hooks/useToggle.js
var useToggle = __webpack_require__(981);
// EXTERNAL MODULE: ./styles/Search.module.css
var Search_module = __webpack_require__(3253);
var Search_module_default = /*#__PURE__*/__webpack_require__.n(Search_module);
// EXTERNAL MODULE: ./components/Post.js
var Post = __webpack_require__(4438);
;// CONCATENATED MODULE: ./components/SearchPosts.js









var Search = function(param) {
    var list = param.list, keys = param.keys, placeholder = param.placeholder, language = param.language;
    list = list.map(function(post) {
        if (!Array.isArray(post.tags)) post.tags = post.tags.split(",");
        if (!Array.isArray(post.keywords)) post.keywords = post.keywords.split(",");
        return post;
    });
    var ref = (0,react.useState)(""), searchTerm = ref[0], updateSearchTerm = ref[1];
    var ref1 = (0,react.useState)([]), searchResults = ref1[0], updateSearchResults = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), searchResultsShown = ref2[0], toggleSearchResultsShown = ref2[1];
    hooks_useDebounce(function() {
        return search(searchTerm);
    }, 700, [
        searchTerm
    ]);
    var search = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(pattern) {
            var options, Fuse, fuse, results, relevantResultData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        options = {
                            includeScore: true,
                            minMatchCharLength: 3,
                            findAllMatches: true,
                            ignoreLocation: true,
                            keys: keys
                        };
                        _ctx.next = 3;
                        return __webpack_require__.e(/* import() */ 221).then(__webpack_require__.bind(__webpack_require__, 4221));
                    case 3:
                        Fuse = _ctx.sent.default;
                        fuse = new Fuse(list, options);
                        results = fuse.search(pattern);
                        relevantResultData = results.filter(function(result) {
                            return result.score < 0.6;
                        }).slice(0, 3).map(function(result) {
                            return result.item;
                        });
                        toggleSearchResultsShown(true);
                        updateSearchResults(relevantResultData);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function search(pattern) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleInput = function(e) {
        updateSearchTerm(e.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Search_module_default()).Search,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Search_module_default()).Label,
                children: language === "en" ? "Search posts" : "Etsi julkaisuja"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                onChange: handleInput,
                onFocus: function() {
                    return toggleSearchResultsShown(true);
                },
                onBlur: function() {
                    if (searchResults.length === 0) toggleSearchResultsShown(false);
                },
                placeholder: placeholder,
                className: searchResultsShown ? (Search_module_default()).ResultsShown : undefined
            }),
            searchResultsShown && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Search_module_default()).Results,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Search_module_default()).CloseButton,
                        onClick: function() {
                            return toggleSearchResultsShown(false);
                        },
                        children: "\xd7"
                    }),
                    searchResults.length > 0 ? searchResults.map(function(result, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Post/* default */.Z, {
                            post: result,
                            compact: true,
                            language: language
                        }, i);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Search_module_default()).NoResults,
                        children: [
                            language === "en" ? "No results for:" : "Ei tuloksia haulle:",
                            " ",
                            searchTerm
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SearchPosts = (Search);


/***/ }),

/***/ 3294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Advert__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1682);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3510);
/* harmony import */ var _components_Pagination__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5625);
/* harmony import */ var _components_Post_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4438);
/* harmony import */ var _components_SearchPosts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1340);
/* harmony import */ var _styles_PostPage_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4854);
/* harmony import */ var _styles_PostPage_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_PostPage_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);








var BlogPage = function(param) {
    var posts = param.posts, numPages = param.numPages, currentPage = param.currentPage, tags = param.tags;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        title: "Blog | Joonas Niemenjoki",
        i18n: "https://niemenjoki.fi/",
        language: "en",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                children: "Latest posts"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SearchPosts__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                list: posts,
                keys: [
                    "title",
                    "excerpt",
                    "keywords",
                    "tags"
                ],
                placeholder: "Search posts by title or keyword..",
                language: "en"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_PostPage_module_css__WEBPACK_IMPORTED_MODULE_7___default().Taglist),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_styles_PostPage_module_css__WEBPACK_IMPORTED_MODULE_7___default().Tag) + " " + (_styles_PostPage_module_css__WEBPACK_IMPORTED_MODULE_7___default().ActiveTag),
                            children: "All posts"
                        })
                    }),
                    tags.sort(function(a, b) {
                        return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
                    }).map(function(tag) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                            href: "/blog/".concat(tag.toLowerCase(), "/page/1"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: (_styles_PostPage_module_css__WEBPACK_IMPORTED_MODULE_7___default().Tag),
                                children: tag
                            })
                        }, tag);
                    })
                ]
            }),
            posts.filter(function(post) {
                return post.onPage === true;
            }).map(function(post, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Post_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    post: post,
                    language: "en"
                }, index);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Pagination__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                numPages: numPages,
                currentPage: currentPage,
                language: "en"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Advert__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                language: "en"
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogPage);


/***/ }),

/***/ 3027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__glaqd","TextButton":"Pagination_TextButton__Ol17o","NumberButton":"Pagination_NumberButton__gOtQl","ActiveButton":"Pagination_ActiveButton__gEU_b"};

/***/ }),

/***/ 2106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Post":"Post_Post__y18Vk","Title":"Post_Title__iKyDh","Excerpt":"Post_Excerpt__yMdge","Tags":"Post_Tags__we__h","Tag":"Post_Tag__D57Ir","Arrow":"Post_Arrow__jth_i"};

/***/ }),

/***/ 4854:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PostPage":"PostPage_PostPage__Do8bS","Date":"PostPage_Date__OOjIf","Kryptex":"PostPage_Kryptex__PBD5I","Content":"PostPage_Content__SNKq9","Taglist":"PostPage_Taglist__YU7IE","Tag":"PostPage_Tag__Jnmr6","ActiveTag":"PostPage_ActiveTag__lWA0z"};

/***/ }),

/***/ 3253:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Search":"Search_Search__MRTqt","ResultsShown":"Search_ResultsShown__pTUEq","Label":"Search_Label__K6s5s","Results":"Search_Results__1zwOV","NoResults":"Search_NoResults__f4Lze","CloseButton":"Search_CloseButton__DECRA"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [976,948,913,510,774,888,179], function() { return __webpack_exec__(5033); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);